import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { validateAdvancedBookingDays, getValidateAdvancedBookingDaysErrorMsg } from './utility';
import { areEqual } from '../components/utility';
import { getAbwBasicConfig, advancedBookingDefaultSetting } from './basic-config';

export const AdvancedBookingWindowTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, apiErrors,
  } = props;
  const advancedBookingDaysError = value => getValidateAdvancedBookingDaysErrorMsg({ code: validateAdvancedBookingDays({ value }), i18n });

  const handleAddLine = () => {
    const currentLevelSettings = [...data.currentLevelSettings, ...advancedBookingDefaultSetting];
    props.setData({ ...data, currentLevelSettings });
  };

  const params = {
    ...getAbwBasicConfig(i18n),
    handleAddLine,
    getFieldErrorMsg: advancedBookingDaysError,
    validateParams: { targetId: 'abw-target-wrapper', patchErrMsg, targetName: 'ABW' },
    patchTargetsApiErrMsg,
    apiErrors,
  };


  return (
    <div id="abw-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, areEqual);

AdvancedBookingWindowTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  apiErrors: PropTypes.arrayOf(PropTypes.string),
};

AdvancedBookingWindowTargetSetting.defaultProps = {
  patchErrMsg() { },
  patchTargetsApiErrMsg() {},
  apiErrors: [],
};
